import useSWR from 'swr';
import { ProductName } from '@globalConstants';
import { useCustomerId } from '@hooks';

export interface LimitsByCustomer {
  segments: Segment[];
  products: Product[];
}

export interface Segment {
  segmentNumber: number;
  name: string;
}

export interface Product {
  id: string;
  name: ProductName;
  colors?: ProductColors;
  subSegments: SubSegment[];
}

export interface ProductColors {
  main?: string;
  light?: string;
  dark?: string;
  contrast?: string;
}

export interface SubSegment {
  segmentNumber: number;
  name: string;
  limits: LimitEntry[];
}

export interface LimitEntry {
  transactionType: string;
  dailyLimit: string;
  monthlyLimit: string;
}

/** Get customer limits */
const useCustomerLimits = () => {
  const { customerId } = useCustomerId();
  const { data, isLoading, error } = useSWR<LimitsByCustomer>(
    customerId ? `/v2/partner/limits/customer/${customerId}` : null,
    {
      revalidateOnFocus: false,
    }
  );
  return { data: data || { segments: [], products: [] }, isLoading, error };
};

export default useCustomerLimits;
